var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group has-float-label"},[_c('b-input',{staticClass:"form-control",class:_vm.cssClass,attrs:{"id":_vm.inputId,"size":_vm.size,"placeholder":" ","type":_vm.inputType,"name":_vm.name,"value":_vm.value},on:{"input":(e) => _vm.$emit('input', e)}}),_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.lableText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }